import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import { PropertyDetailsLayout } from '@acp/core-ui';

const IntegratedPropertyDetailsPage = React.lazy(() => import('../features/property-details/integrated-property/page'));

export function IntegratedPropertyDetails() {
    const params = useParams();
    const agencyPortfolioPropertyId = Number(params.agencyPortfolioPropertyId);

    return (
        <Suspense fallback={<PropertyDetailsLayout.Skeleton />}>
            <IntegratedPropertyDetailsPage agencyPortfolioPropertyId={agencyPortfolioPropertyId} />
        </Suspense>
    );
}
